<template>
  <div class="mock-paquetes" v-if="!isProduction">
    <span
      ><input type="checkbox" v-model="mock" @change="_dispatch" />Mock
      respuesta</span
    >
    <div v-if="mock">
      <p>
        Se evitará el request a backend y se mostrará la oferta con el paquete
        seleccionado
      </p>
      <select v-model="mock" @change="_dispatch">
        <option
          v-for="option in options"
          :value="option.value"
          v-bind:key="option.value"
          >{{ option.label }}</option
        >
      </select>
    </div>
  </div>
</template>

<script>
import { mockOptions } from "@/__mocks__";
import { DO_MOCK } from "../../config/constants/action-types";

export default {
  name: "Mock",
  data() {
    return {
      mock: this.$store.getters.getMock(),
      isProduction: process.env.NODE_ENV === "production"
    };
  },
  computed: {
    options() {
      return Object.keys(mockOptions).map(codigo => {
        return {
          value: codigo,
          label: mockOptions[codigo]
        };
      });
    }
  },
  methods: {
    _dispatch() {
      if (this.mock) {
        this.$store.dispatch(DO_MOCK, this.mock);
      } else {
        this.$store.dispatch(DO_MOCK, null);
      }
    }
  }
};
</script>

<style scoped>
.mock-paquetes {
  background-color: yellow;
  padding: 10px;
  margin-bottom: 20px;
}
input {
  -webkit-appearance: checkbox;
  width: 20px;
  height: auto;
}
</style>
